import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CurrencyInput extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
  }

  static defaultProps = {
    required: false,
    placeholder: '100,000',
  }

  constructor(props) {
    super(props);

    this.state = {
      currentValue: this.convertFloatToUsFormat(this.props.initialValue),
      parsedValue: this.parseCurrency(this.props.initialValue),
    };
  }

  render() {
    return (
      <div>
        <input
          type="text"
          value={this.state.currentValue}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          className={this.props.required ? 'required' : 'optional'}
        />
        <input type="hidden" name={this.props.name} value={this.state.parsedValue} />
      </div>
    );
  }

  handleChange = (e) => {
    const newValue = this.discardLetters(e.target.value);
    const parsedValue = this.parseCurrency(newValue);

    this.setState({ currentValue: newValue, parsedValue });
  }

  // Ignore letters in this input
  discardLetters(value) {
    return value.replace(/[a-zA-Z]/g, '');
  }

  // Parse the numeric value out of the input value. This is so we can support
  // numbers like $100,000,000.0
  parseCurrency(value) {
    if (value === null) { return; }
    return value.replace(/[^\d\.-]/g, '');
  }

  // This converts the initial value (which we assume is a float string) to the
  // en-US format: 100,000,000.123
  convertFloatToUsFormat(value) {
    const float = parseFloat(value);
    if (isNaN(float)) { return ''; }
    return float.toLocaleString('en-US');
  }
}
